import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import Translate from 'react-translate-component';

class ActivityDasboardButton extends React.Component {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    buttonStyle: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    openTab: PropTypes.bool
  };

  render () {
    return (
      <Link
        to={this.props.link}
        className={'dashboard-button ' + this.props.buttonStyle}
        target={this.props.openTab ? '_blank' : '_self'}
      >
        <img className={'dashboard-button-icon ' + this.props.buttonStyle} src={this.props.icon} />
        <Translate
          className={'dashboard-button-text ' + this.props.buttonStyle}
          content={this.props.title}
        />
      </Link>
    );
  }
}

export default ActivityDasboardButton;



/** WEBPACK FOOTER **
 ** ./src/components/dashboard-buttons/dashboard-button.js
 **/